import type { IUserInfoExtended } from "app/components/SharingModal/types";

import type { IRawUser } from "./types";

export const transformUser = (user: IRawUser): IUserInfoExtended => {
    const email = user.Email ?? "";
    const emailPrefix = email.split("@")?.[0] ?? "";
    const firstName = user.FirstName ?? emailPrefix.split(".")?.[0] ?? "";
    const lastName = user.LastName ?? emailPrefix.split(".").slice(1).join(" ") ?? "";
    const text = user.User ?? (user.AccountName ? `${email} (${user.AccountName})` : email);

    return {
        id: user.Id,
        email,
        firstName,
        lastName,
        text,
    };
};
